// GA4 conversion events, sent through the gtag snippet in public/index.html.
// Mark these events as key events in GA4 to count them as conversions.
export function track(event, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  } catch { /* analytics must never break the page */ }
}
